import axios                      from "axios";
import {
  call,
  cancel,
  cancelled,
  delay,
  put,
  select,
  takeEvery,
  takeLatest
}                                 from 'redux-saga/effects';
import service                    from "../../services";
import { Routes }                 from "../../types";
import {
  setCameraStreamError,
  setCameraStreamFetch,
  setCameraStreamName,
  setCameraStreamStatus,
  setCameraStreamSuccess,
  setCapibilities,
  setDeviceStatus,
  setPresets
}                                 from "../cameras/actions";
import { chooseServiceGenerator } from "./utils";


function* disconnect(token, pane, service) {
  try {
    yield service.disconnectPane(token, pane);
  } catch (err) {
    console.error(err)
  }
}

function* ocularisGetOneStreamName(action) {
  const {options} = action;
  const {pane, requestId, token, cameraId} = options;
  const API = yield select(state => state.API);
  const sessionToken = API.token;

  yield put(setCameraStreamFetch(pane, requestId));

  try {
    let deviceStatus = yield call(service.deviceStatus, ...[sessionToken, cameraId, pane]);
    const {currentCameras} = yield select(state => state.cameras);
    const {location} = yield select(state => state.router);
    if (!currentCameras[pane] && location.pathname !== Routes.alerts) return;
    yield put(setDeviceStatus(pane, deviceStatus.device_status));
    if (deviceStatus.device_status === 'online') {
      const res = yield call(service.getStreamName, options);
      yield put(setCameraStreamSuccess(res, pane));

      try {
        const capibilities = yield call(() => service.getCapibilities(token, pane));
        yield put(setCapibilities(capibilities.data, pane));

        const {data} = yield call(() => service.getPresets(token, pane));
        yield put(setPresets(data.presets, pane));
      } catch (e) {
        if (yield !cancelled()) {
          yield put(setCameraStreamName(options));
        }
      }
    } else {
      for (let i = 0; i < 5; i++) {
        yield delay(5000);
        deviceStatus = yield call(service.deviceStatus, ...[sessionToken, cameraId, pane]);
        if (deviceStatus.device_status === 'online') {
          yield put(setCameraStreamName(options));
          break;
        }
      }

      if (deviceStatus.device_status === 'offline') {
        yield put(setCameraStreamStatus({data: 'Camera is offline', status: 'offline'}, pane));
        service.clearId(requestId);

        yield delay(30000);
        yield put(setCameraStreamName(options));
      }
    }
  } catch (err) {
    if (yield !cancelled()) {
      if (!axios.isCancel(err)) {
        yield put(setCameraStreamError(err.message, pane));
        service.clearId(requestId);
      }
    }
  }
}

function* cayugaGetOneStreamName(action) {
  const {options} = action;
  const {cameraId, width, height, token, streamId, requestId, pane} = options;
  const codec = 'mjpeg';
  try {
    const res = yield call(service.startLiveStream, token, cameraId, codec, 30, width, height)
    yield put(setCameraStreamSuccess(res.data, pane));

  } catch (e) {

  }
}

function* cancelDeviceStatus(task) {
  yield cancel(task);
  const newTask = yield takeEvery('getStreamName', chooseServiceGenerator,
    {fn: ocularisGetOneStreamName, args: []},
    {fn: cayugaGetOneStreamName, args: []}
  );
  yield takeLatest('cancelDeviceStatus', cancelDeviceStatus, newTask);
}

export default function* getStreamNameSaga() {
  let task = yield takeEvery('getStreamName', chooseServiceGenerator,
    {fn: ocularisGetOneStreamName, args: []},
    {fn: cayugaGetOneStreamName, args: []}
  );
  yield takeLatest('cancelDeviceStatus', cancelDeviceStatus, task);
}